import Applications from "./Applications";
import ApplicationDeploymentsTrack from "./ApplicationDeploymentsTrack";
import Settings from "./Settings";
import AppDataModal from "./AppDataModal";
import * as selectors from "./applications.selectors";
import * as slice from "./applications.reducers";
import * as useQueryActions from "./applications.actions";

export const {
  name,
  actions: {
    setSelectedAppId,
    setSelectedApp,
    setSelectedNavigation,
    setShouldShowSidePanel,
    setShouldShowMenuBar,
    setIsFetching,
    setSelectedModal,
    setApplicationFilters,
    setShouldShowLeftPane,
    setAppDeployStatus,
    setRecentlySelectedApp,
    setAppPipelineStatus,
  },
  reducer,
} = slice;

export const {
  createApplication,
  fetchApplications,
  fetchApplicationById,
  updateApplication,
  deleteApplication,
  fetchConstantsFromLibrary,
  fetchApplicationDeploymentStatus,
  fetchApplicationsDeploymentsTrack,
} = useQueryActions;

export const {
  selectApplications,
  selectSelectedAppId,
  selectSelectedApp,
  selectShouldShowSidePanel,
  selectShouldShowMenuBar,
  selectSelectedModal,
  selectTotalApplications,
  selectApplicationFilters,
  selectPredefinedProperties,
  selectPredefinedCollections,
  selectNodes,
  selectShouldShowLeftPane,
  selectApplicationsTemplates,
  selectBackendTemplates,
  selectAppDeployStatus,
  selectRecentSelectedApp,
  selectAppPipelineStatus,
  selectApplicationDeploymentsTrack,
} = selectors;

export { Applications, Settings, AppDataModal, ApplicationDeploymentsTrack };
